import React from 'react';

import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import Cod from './Cod';
import CreditCard from './CreditCard';
import DebitCard from './DebitCard';
import Emi from './Emi';
import NetBanking from './NetBanking';

const PaymentDetailContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs justify='end' pageTitle='Payment Details' parent='Ecommerce' title='Payment Details' />
      <Row>
        <CreditCard />
        <DebitCard />
        <Cod />
        <Emi />
        <NetBanking />
      </Row>
    </Container>
  );
};

export default PaymentDetailContainer;
